export enum LotteryError {
	LOTTERY_ENDED = 'Lottery has ended',
}
